const Shelf = () => import("@/views/shelves/Shelf.vue")
const Render = () => import("@/views/shelves/Render.vue")

export default {

    path: "/shelf",
    component: Shelf
    , children: [{ name: "shelf", path: "", component: Render },]
}